import * as React from "react";
import "../../../assets/scss/Login/login/generic/loginErrMsg.scss";

export interface ILoginErrMsgProps {
  className?: string; // extra classname(s) if necessary
}

const LoginErrMsg: React.FC<ILoginErrMsgProps> = (props) => {
  return (
    <p className={"login_err_msg pd-all10 " + (props.className || "")}
    role="alert"
    aria-live="assertive"
    aria-atomic="true">
      {props.children}
    </p>
  );
};

export default LoginErrMsg;
